// Constants
export const ADDRESS_LOADING = 'ADDRESS_LOADING';
export const ADDRESSES_FULFILLED = 'ADDRESSES_FULFILLED';
export const ADDRESS_FULFILLED = 'ADDRESS_FULFILLED';
